import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useSettings } from "@/context/SettingsContext";

// Injects Google Analytics (GA4) and the Google Search Console verification meta
// tag site-wide, using IDs configured by the admin in Admin → Settings.
// GA scripts are injected imperatively (Helmet does not reliably execute inline
// <script> tags), so tracking fires as soon as a GA4 ID is set.
export default function Analytics() {
  const { ga4_id, gsc_code } = useSettings();

  useEffect(() => {
    if (!ga4_id || document.getElementById("ga4-src")) return;
    const s1 = document.createElement("script");
    s1.id = "ga4-src";
    s1.async = true;
    s1.src = `https://www.googletagmanager.com/gtag/js?id=${ga4_id}`;
    document.head.appendChild(s1);
    window.dataLayer = window.dataLayer || [];
    function gtag() { window.dataLayer.push(arguments); }
    window.gtag = gtag;
    gtag("js", new Date());
    gtag("config", ga4_id);
  }, [ga4_id]);

  if (!gsc_code) return null;
  return (
    <Helmet>
      <meta name="google-site-verification" content={gsc_code} />
    </Helmet>
  );
}
